import { EditProfile } from "./EditProfile";

export const EditProfileQueryRenderer = () => {
  return <EditProfile />;
};
